<div class="footer-pages-content" *ngFor="let item of contentArr">
    <h4>{{item.title}}</h4>
    <div [innerHTML]="item.paragraph"></div>
</div>
